<div class="main-content">
    <res-top-nav-bar></res-top-nav-bar>
    <div class="content">
        <div id="leftContent" [resBusySpinner]="isBusy" [message]="isBusyMessage">
            <res-generic-tree #dashboardTree automationId="nav-tree"
                [selectedNodeChangedCallback]="selectedNodeChangedCallback"
                [onContextMenuActionCallback]="onContextMenuActionCallback"
                [customClasses]="navigationTree.isVerticalScrollbarVisible() ? 'generic-tree-navigation-header-panels generic-tree-border-bottom' :'generic-tree-navigation-header-panels'">
            </res-generic-tree>
            <res-generic-tree #navigationTree class="navigation-tree"
                customClasses="generic-tree-navigation-header-panels generic-tree-header-panels-chevron-expanders generic-tree-header-panel-border-top generic-tree-border-bottom"
                automationId="nav-tree" [checkPermissions]="true" [finishLoadingCallback]="finishLoadingCallback"
                [selectedNodeChangedCallback]="selectedNodeChangedCallback"
                [onContextMenuActionCallback]="onContextMenuActionCallback"
                [checkboxSelectionChangedCallback]="checkboxSelectionChangedCallback"
                [preselectNodeCallback]="preselectNodeCallback">
            </res-generic-tree>
            <div class="nav-tree-toolbar">
                <res-custom-checkbox automationId="nav-tree-hide-archived-items" [(ngModel)]="hideArchivedItems" [titleText]="hideArchivedTooltip"
                    (ngModelChange)="hideArchivedItemsSelectionChanged()" content="Hide Archived Items" [marginLeft]="5"
                    [disabled]="isBusy"></res-custom-checkbox>
            </div>
        </div>
        <res-resizer anchor="left" resizingElementId="leftContent" secondElementId="middleContent" thirdElementId="rightContent" [collapsible]="true"
            [resizeCallback]="searchComponent.resizeCallback" [initSize]="220" [marginToMaxParentSize]="10"
            collapsedIcon="fa-sitemap" collapsedTitle="Show Navigation Tree">
        </res-resizer>
        <div id="middleContent">
            <div id="topContent">
                <res-breadcrumb (breadcrumbClicked)="breadcrumbClicked($event)"></res-breadcrumb>
                <res-search></res-search>
            </div>
            <res-resizer [hidden]="searchType === 'ADVANCED'" #searchBarResizer anchor="up"
                resizingElementId="topContent" [collapsibleToMinSize]="true" secondElementId="bottomContent"
                [initSize]="120" [minSize]="120" [collapsed]="true"></res-resizer>

            <div id="bottomContent">
                <div [hidden]="!nullViewType" id="nullViewMessageScreen">
                    <span>
                        <div class="hint-popover">
                            <i class="fa fa-exclamation-circle"></i>Search target is no longer available.
                        </div>
                    </span>
                </div>
                <div [hidden]="nullViewType" id="notEmptyView">
                    <div id="comparisonContent"
                        *ngIf="selectedNode && selectedNode.entityType === 'comparison' && selectedNode.level === 2">
                        <div class="comparisonView">
                            <div class="letterBox">Set A</div>
                            <div class="comparisonDescription">
                                <i class="fa {{comparisonViewA.icon}} {{comparisonViewA.iconColor}}"
                                    [ngStyle]="{color: comparisonViewA.iconHexColor ? comparisonViewA.iconHexColor : ''}"></i>
                            </div>
                            <div class="text" title="{{comparisonViewA.name}}">{{comparisonViewA.name}}</div>
                        </div>
                        <i class="fa fa-exchange"></i>
                        <div class="comparisonView">
                            <div class="letterBox">Set B</div>
                            <div class="comparisonDescription">
                                <i class="fa {{comparisonViewB.icon}} {{comparisonViewB.iconColor}}"
                                    [ngStyle]="{color: comparisonViewB.iconHexColor ? comparisonViewB.iconHexColor : ''}"></i>
                            </div>
                            <div class="text" title="{{comparisonViewB.name}}">{{comparisonViewB.name}}</div>
                        </div>
                        <button type="button" class="secondary-button edit-comparison" *ngIf="hasComparisionPermissions"
                            (click)="editComparison()"> <i class="fa fa-pencil"></i>Edit...
                        </button>
                        <div class="comparisonDropdown">
                            <span>List:</span>
                            <res-custom-select [items]="dropdownListComparison"
                                [selectedItem]="selectedDropdownListComparison" customClass="dropdown"
                                [optionHeight]="50" [onSelectionChanged]="selectedComparisonTypeChanged"
                                automationId="comparison-dropdown">
                            </res-custom-select>
                        </div>
                    </div>
                    <ul class="nav nav-tabs" *ngIf="tabsBarVisible()"
                        [ngStyle]="{'margin-bottom': helpButtonVisible() ? '10px' : '0px'}">
                        <li *ngFor="let tab of selectedNode.navigationInfo.tabs"
                            [ngClass]="{'active': selectedNode.navigationInfo.selectedTab && selectedNode.navigationInfo.selectedTab.name === tab.name }"
                            [attr.data-automation-id]="'main-content-' + tab.path + '-tab'" (click)="selectTab(tab)">
                            <a>{{tab.name}}</a>
                        </li>
                        <button type="button" class="help-button" *ngIf="helpButtonVisible()"
                            data-automation-id="main-content-help-button" (click)="openHelp()">
                            <i class="fa fa-question"></i>
                        </button>
                    </ul>
                    <div class="help-header" *ngIf="!tabsBarVisible() && helpButtonVisible()">
                        <button type="button" class="help-button" data-automation-id="main-content-help-button"
                            (click)="openHelp()">
                            <i class="fa fa-question"></i>
                        </button>
                    </div>
                    <router-outlet name="project-focus" (activate)="onRouterOutletActivate($event)"></router-outlet>
                </div>
            </div>
        </div>
        <res-resizer anchor="right" resizingElementId="rightContent" secondElementId="middleContent"
            [resizeCallback]="searchComponent.resizeCallback" [collapsible]="true" [collapsed]="true" [initSize]="600"
            [minSize]="385" customClass="blueResizer" collapsedIcon="fa-shopping-basket"
            collapsedTitle="Show Workbasket" *ngIf="hasWorkBasketAccess"
            [attr.data-automation-id]="'workbasket-resizer-button'">
        </res-resizer>
        <div id="rightContent" *ngIf="hasWorkBasketAccess">
            <res-workbasket [collapseCallback]="toggleWorkbasket.bind(this)"></res-workbasket>
        </div>
    </div>
</div>